import { render, staticRenderFns } from "./modal_ekspor.vue?vue&type=template&id=6c1f2339&scoped=true"
import script from "./modal_ekspor.vue?vue&type=script&lang=js"
export * from "./modal_ekspor.vue?vue&type=script&lang=js"
import style0 from "./modal_ekspor.vue?vue&type=style&index=0&id=6c1f2339&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1f2339",
  null
  
)

export default component.exports